import { useChatContext } from 'stream-chat-react';
import type { Channel } from 'stream-chat';

// 'channel' property should be reactive for correct work of this hook,
// otherwise it will not update the state on channel changes
// Can be used inside ChannelList (like channel preview components),
// but not in Channel or MessageList (because of the way Stream SDK handles re-rendering of these components)
export function useChannelPreviewState(channel?: Channel) {
  const { client, channel: activeChannel } = useChatContext();
  const userId = client.userID;

  const isMember = Boolean(userId && channel?.state.members?.[userId]);
  const isActive = activeChannel?.id === channel?.id;
  const isPinned = !!channel?.state?.membership?.pinned_at;
  const isMuted = !!client.mutedChannels?.some((m) => m.channel?.id === channel?.id);

  const getMentionCount = () => channel?.countUnreadMentions() || 0;

  const getUnread = () => {
    if (!channel) return 0;
    const baseUnread = channel.countUnread();
    if (!isMember) return 0;
    if (isActive) return 0;
    return isMuted ? getMentionCount() : baseUnread;
  };

  return {
    isPinned,
    isMember,
    isMuted,
    isActive,
    getUnread,
    getMentionCount,
  };
}
